module.exports = __webpack_public_path__ + "static/media/humid_icon.fdbabbc5.png";